export default __webpack_public_path__ + "static/howwork1-4a00c3eff42b1f6705439a34528cc521.jpg";